import React from "react";

import { HorizontalList } from "@common/horizontalList";
import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function IndicatorsList({}: Props) {
  return (
    <HorizontalList>
      <div className={styles.indicatorsList}>
        <div className={styles.input}>
          <Skeleton className={styles.indicator} />
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.input}>
          <Skeleton className={styles.indicator} />
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.input}>
          <Skeleton className={styles.indicator} />
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.input}>
          <Skeleton className={styles.indicator} />
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.input}>
          <Skeleton className={styles.indicator} />
          <Skeleton className={styles.name} />
        </div>
      </div>
    </HorizontalList>
  );
}

export { IndicatorsList };
